<template>
  <span class="c-heading-type" :data-level="level">{{ level }}</span>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      required: true
    }
  }
};
</script>
